const pageClassMap = {

  // ========================
  // ROUTE CLASS MAPPING
  // ========================
  '/': 'main-home',
  '/about': 'main-about',
  '/contact': 'main-contact',
  '/projets': 'main-projects',
};

export default pageClassMap;